export enum UserRole {
  SystemAdmin = 1,
  TenantAdmin = 2,
  Viewer = 3,
}

export enum PermissionType {
  Read = 1,
  Admin = 2,
}

export interface User {
  id: string;
  username: string;
  email: string;
  role: UserRole;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
}

export interface UserTenant {
  tenantId: string;
  tenantName: string;
  permissionType: PermissionType;
  createdAt: string;
}

export interface CreateUserRequest {
  username: string;
  email: string;
  password: string;
  role: UserRole;
}

export interface UpdateUserRequest {
  id: string;
  username: string;
  email: string;
  password?: string;
  role: UserRole;
}

export interface AssignTenantPermissionRequest {
  userId: string;
  tenantId: string;
  permissionType: PermissionType;
}
